import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import classNames from 'classnames'

import Image from 'components/Form/Image'

import useSizeDetector from 'hooks/useSizeDetector'

import { FIELD_KEYS } from '../../../../constants'

import { getAgreementData } from './utils'

import './Preview.scss'

const AgreementBlock = ({ url, text }) => (
    <a rel="noopener noreferrer" target="_blank" href={url}>
        {text}
    </a>
)

const Preview = ({
    backgroundColor,
    color,
    fontFamily,
    fields = [],
    logoImage,
    headerText = '',
    descriptionText = '',
    buttonText = '',
    linkPrivacyPolicyLink = '',
    additionalNotes = '',
}) => {
    const { t } = useTranslation()

    const [isMobile, setIsMobile] = useState(false)

    const { ref: previewRef, width } = useSizeDetector()

    const getAgreementBlock = () => {
        const linksArray = linkPrivacyPolicyLink.split('|').filter(link => !!link)

        if (linksArray.length === 1) {
            const agreementData = getAgreementData(linksArray[0], t('Privacy Policy'))
            return <AgreementBlock url={agreementData.url} text={agreementData.text} />
        }

        return linksArray.map((link, index) => {
            const agreementData = getAgreementData(link)

            return (
                <>
                    <AgreementBlock key={index} url={agreementData.url} text={t(agreementData.text)} />
                    {index !== linksArray.length - 1 ? ', ' : null}
                </>
            )
        })
    }

    useEffect(() => {
        setIsMobile(width < 800)
    }, [width])

    return (
        <div ref={previewRef}>
            <div
                className={classNames('lead-form-form-review', { 'lead-form-form-review--is-mobile': isMobile })}
                style={{ backgroundColor }}
            >
                {!!logoImage ? <Image className="logo-image" src={logoImage} alt="logo" /> : null}
                {!!headerText.length && (
                    <div className="header" style={{ fontFamily: `"${fontFamily || 'Roboto'}", sans-serif`, color }}>
                        {headerText}
                    </div>
                )}
                {!!descriptionText.length && (
                    <div
                        className="description"
                        style={{ fontFamily: `"${fontFamily || 'Roboto'}", sans-serif`, color }}
                    >
                        {descriptionText}
                    </div>
                )}
                <ul className="fields">
                    {fields.map(field => (
                        <li
                            key={field.key}
                            className={classNames(field.type, {
                                'is-half':
                                    !isMobile &&
                                    ((field.key === FIELD_KEYS.FIRST_NAME &&
                                        !!fields.find(el => el.key === FIELD_KEYS.LAST_NAME)) ||
                                        (field.key === FIELD_KEYS.LAST_NAME &&
                                            !!fields.find(el => el.key === FIELD_KEYS.FIRST_NAME))),
                            })}
                        >
                            <p style={{ color }}>{t(field.label)}</p>
                            <div />
                        </li>
                    ))}
                </ul>
                {!!linkPrivacyPolicyLink.length && (
                    <div className="privacy-wrapper">
                        <div className="privacy">
                            <span />
                            <div style={{ display: 'inline', color }}>{t('Agree with')}</div>
                            &nbsp;
                            {getAgreementBlock()}
                        </div>
                    </div>
                )}
                {!!additionalNotes && (
                    <div className="additional-notes" style={{ color }}>
                        {additionalNotes}
                    </div>
                )}
                {!!buttonText.length && (
                    <div className="button-wrapper">
                        <button
                            style={{
                                backgroundColor: color,
                                color: backgroundColor,
                                fontFamily: `"${fontFamily || 'Roboto'}", sans-serif`,
                            }}
                        >
                            {buttonText}
                        </button>
                    </div>
                )}
            </div>
        </div>
    )
}

export default Preview
